/**
 * Front-end constants describing the session cookie set by the backend at
 * src/http.rs::feishu_callback. The console never reads or writes the cookie
 * itself (it is HttpOnly); these values are purely informational, displayed on
 * Screen 2 (Overview) so operators can verify the metadata.
 */
export const SESSION_COOKIE = {
  name: 'identity_session',
  httpOnly: true,
  sameSite: 'Lax' as const,
  secure: true,
  path: '/',
};
